import { useEffect, useState } from 'react';
import axios from 'axios';
import Modal from './Modal';
import InlineLoader from '../Loader/InlineLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft, faLocationDot, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faWindows, faApple, faAndroid, faLinux } from '@fortawesome/free-brands-svg-icons';
import { formatRelativeDate, formatFullDate } from '../../utils/FormatDate';
import { API_BASE_URL } from '../../api';

const osIcon = (os) => {
  const o = (os || '').toLowerCase();
  if (o.includes('windows')) return faWindows;
  if (o.includes('mac') || o.includes('ios')) return faApple;
  if (o.includes('android')) return faAndroid;
  if (o.includes('linux')) return faLinux;
  return faGlobe;
};

export default function LoginHistoryModal({ show, onClose }) {
  const [entries, setEntries] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchPage = (pageToLoad) => {
    setLoading(true);
    axios.get(`${API_BASE_URL}/api/v1/login-history`, {
      withCredentials: true,
      params: { page: pageToLoad, size: 20 },
    })
      .then(({ data }) => {
        setEntries(prev => pageToLoad === 0 ? (data.content || []) : [...prev, ...(data.content || [])]);
        setHasMore(!data.last);
        setPage(pageToLoad + 1);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!show) return;
    setEntries([]);
    setPage(0);
    setHasMore(false);
    fetchPage(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <Modal
      title="Historique de connexion"
      show={show}
      onClose={onClose}
      icon={faClockRotateLeft}
      iconBg="#eff6ff"
      iconColor="#1d4ed8"
    >
      <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>
        Les dernières connexions à votre compte — appareil, localisation approximative et adresse IP.
      </p>

      {loading && entries.length === 0 ? (
        <InlineLoader small />
      ) : entries.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 24, color: '#9ca3af', fontSize: 13 }}>
          Aucune connexion enregistrée.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {entries.map((entry, i) => (
            <div
              key={entry.id}
              style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '10px 12px', border: '1px solid #f0f1f3', borderRadius: 10,
                background: i === 0 ? '#f0fdf4' : '#fff',
              }}
            >
              <span style={{
                width: 34, height: 34, borderRadius: 9, flexShrink: 0,
                background: i === 0 ? '#dcfce7' : '#f1f5f9', color: i === 0 ? '#16a34a' : '#64748b',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14,
              }}>
                <FontAwesomeIcon icon={osIcon(entry.operatingSystem)} />
              </span>

              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: '#111827' }}>
                    {entry.operatingSystem || 'Appareil inconnu'}{entry.browser ? ` · ${entry.browser}` : ''}
                  </span>
                  {i === 0 && (
                    <span style={{ fontSize: 10, fontWeight: 700, color: '#16a34a', background: '#dcfce7', padding: '1px 8px', borderRadius: 999, textTransform: 'uppercase' }}>
                      Récent
                    </span>
                  )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 2 }}>
                  <FontAwesomeIcon icon={faLocationDot} style={{ fontSize: 10, color: '#9ca3af' }} />
                  <span style={{ fontSize: 12, color: '#6b7280' }}>
                    {entry.location || 'Localisation inconnue'} · {entry.ipAddress}
                  </span>
                </div>
              </div>

              <span
                style={{ fontSize: 11, color: '#9ca3af', flexShrink: 0 }}
                data-tooltip-id="tooltip"
                data-tooltip-content={formatFullDate(entry.createdAt)}
              >
                {formatRelativeDate(entry.createdAt)}
              </span>
            </div>
          ))}

          {hasMore && (
            <button
              type="button"
              className="btn btn-light btn-sm w-100"
              disabled={loading}
              onClick={() => fetchPage(page)}
            >
              {loading ? <span className="spinner-border spinner-border-sm" /> : 'Charger plus'}
            </button>
          )}
        </div>
      )}
    </Modal>
  );
}
